import { TType } from "types/shared"
import { ISettingItem } from "./SettingsCardsTypes"

export const settingsConfig = (T: TType): ISettingItem[] => (
  [
    {
      id: 0,
      isPremium: false,
      subTitle: T("settings.booking_settings"),
      icon: "bookingsSettings",
      url: "bookings"
    },
    {
      id: 1,
      isPremium: false,
      subTitle: T("settings.cancellation_fee"),
      icon: "cancellationFee",
      url: "cancellation_fee"
    },
    {
      id: 2,
      isPremium: false,
      subTitle: T("settings.booking_fee"),
      icon: "bookingFee",
      url: "booking_fee"
    },
    {
      id: 3,
      isPremium: false,
      subTitle: T("settings.districts"),
      icon: "district",
      url: "/districts"
    },
    {
      id: 4,
      isPremium: true,
      subTitle: T("dashboard.settings"),
      icon: "qappPremium",
      url: ""
    }
    
  ]
)